<template>
  <div style="">
    <div id="admin-preloader" v-if="loading">
      <div id="admin-loader-text">Updating</div>
      <div id="admin-loader"></div>
   </div>
   <div id="admin-preloader" v-if="loading1">
      <div id="admin-loader-text">Loading</div>
      <div id="admin-loader"></div>
   </div>
 <div v-if="changed">
      <div class="m-auto text-right pt-4 pb-3">
        <router-link :to="{name:'allProducts' , params:{cat:this.$route.params.cat}}" class="text-white" style="text-decoration:none;"><el-button type="primary" size="medium"><i class="el-icon-view mr-2"></i>View Products</el-button></router-link>
      </div>
      <commonProducts/>

      <!-- <Mobiles v-if="mobiles"/>

      <Vehicles v-if="vehicles"/> -->
  </div>
  </div>
</template>

<script>
import commonProducts from './commonProducts' 
import Mobiles from './Mobiles' 
import Vehicles from './Vehicles' 
import db from "../../config/FirebaseInit"
import firebase from 'firebase/app';
export default {
   name: 'categories',
   components:{
       commonProducts,
       Mobiles,
       Vehicles
   },
   data(){
    return{
       shops:[],
       shopcat:'',
       shoptype:'' ,
       common:false,
       mobiles:false,
       vehicles:false,
        loading:false,
        loading1:false,
        changed:true,
    }
   },

   created(){
       this.loading1 = true
        this.changed = false
       this.$store.state.secondaryDatabase.collection('shops').where('owner', '==', firebase.auth().currentUser.uid).get()
      .then(querySnapshot => {
      querySnapshot.forEach(doc => {
        const data = {
          'id': doc.id,
          'categories': doc.data().categories,
          'shopcat' : doc.data().cat,
          'shoptype' : doc.data().shoptype,
          'curProducts':doc.data().curProducts
          
        }
        this.shops.push(data)
        this.shopcat = this.shops[0].shopcat
        this.shoptype = this.shops[0].shoptype
         this.loading1 = false
        this.changed = true
        //console.log('shop', this.shops[0])
       
      })
      //  if(this.$route.params.cat == 'Mobiles' && this.shopcat == 'Mobiles & Tablets'){
      //     this.mobiles = true
      //      //console.log(this.mobiles)
      //   }else if(this.$route.params.cat == 'Tablets' && this.shopcat == 'Mobiles & Tablets'){
      //     this.mobiles = true
      //       //console.log(this.mobiles)
      //   }else if(this.$route.params.cat == 'Laptops' && this.shopcat == 'Computers'){
      //     this.mobiles = true
      //       //console.log(this.mobiles)
      //   }else if(this.$route.params.cat == 'Desktops' && this.shopcat == 'Computers'){
      //     this.mobiles = true
      //       //console.log(this.mobiles)
      //   }else if(this.shopcat == 'Vehicles'){
      //     this.vehicles = true
      //       //console.log(this.vehicles)
      //   }else{
      //     this.common = true
      //       //console.log('comon',this.common)
      //   }
    })
   }
}
</script>
<style scoped>
@import url('~@/assets/admin/css/admin-loader.css');
</style>





// WEBPACK FOOTER //
// src/components/admin/Categories.vue